export default {
  namespaced: true,
  state: {
    prayer: null,
    flight: null,
    weather: null,
    weathers: [],
    news: [],
    listener: false
  },
  mutations: {
    setPrayer(state, data) {
      state.prayer = data
    },
    setFlight(state, data) {
      state.flight = data
    },
    setWeather(state, data) {
      state.weather = data
    },
    setWeathers(state, data) {
      state.weathers = data
    },
    setNews(state, data) {
      state.news = data
    }
  },
  getters: {
    prayer: state => {
      return state.prayer
    },
    flight: state => {
      return state.flight?.filter(item => item.arrivals.length || item.departures.length)
    },
    current: state => {
      return state.weather
    },
    news: state => {
      return state.news
    }
  },
  actions: {
    async fetchWeather(context) {
      context.dispatch("listenEvent")

      return __.api.get.weather().then(records => {
        if (!Array.isArray(records) || !records.length) return false
        //Remove last three

        for (const weather of records) {
          weather.forecast = weather.forecast.slice(0, -3).map(item => {
            item.image = item.image.host("v2/assets/images/weather/") + ".jpg"
            return item
          })
          weather.current.image = weather.current.image.host("v2/assets/images/weather/") + ".jpg"
        }
        context.commit("setWeather", records[0])
        context.commit("setWeathers", records)
      })
    },
    async fetchPrayer(context) {
      return __.api.get.prayer().then(records => {
        if (!Array.isArray(records) || !records.length) return false
        context.commit("setPrayer", records.shift() || null)
      })
    },
    async fetchFlight(context) {
      return __.api.get.flight().then(records => {
        if (!Array.isArray(records) || !records.length) return false
        context.commit("setFlight", records)
      })
    },
    async fetchNews(context) {
      return __.api.get.news().then(records => {
        if (!Array.isArray(records) || !records.length) return false
        records = records.map(item => {
          item.logo = item.logo?.host("/api/feeder/news/images/large/")
          item.cardType = "hover"

          item.items = item.items.map(news => {
            news.large = news.image.host("/api/feeder/news/images/large/")
            news.small = news.image.host("/api/feeder/news/images/small/")

            return {
              title: news.title,
              description: news.description,
              parent: item.name,
              date: news.date,
              cover: { xsmall: news.small, small: news.small, medium: news.large, large: news.large },
              gallery: [{ xsmall: news.small, small: news.small, medium: news.large, large: news.large }],
              layout_type: "sidepane"
            }
          })
          return item
        })
        context.commit("setNews", records || [])
      })
    },
    async listenEvent(context) {
      if (context.state.listener) return

      context.state.listener = true
      _$.vue.$on("weather", data => {
        if (!context.state.weather) return context.dispatch("fetchWeather")

        data.weather.isDirty = true
        context.state.weather.current = data.weather
        context.commit("setWeather", context.state.weather)
        return true
      })
    }
  }
}
